const EMAIL_DOMAIN = {
  INVALID: 'Please enter valid domain name',
  EMPTY_REQUEST: 'Please enter request',
  EMPTY_EXPRESSION: 'Please enter expression',
  CREATED: 'Email domain created. Pending for approval.',
  UPDATED: 'Email domain updated.',
  NOT_FOUND: 'Email domain not found.',
  DELETED: 'Email domain deleted.',
  EXPRESSION_ADDED: 'Regular Expression created.',
} as const;

export default EMAIL_DOMAIN;
